import type { IconProps } from "./icon-types";

/**
 * 가로 슬라이더 3줄(트랙 + 빈 원 노브, 노브 위치 엇갈림). 파라미터/설정값 조정 표시에
 * 사용(제품 의미 부여는 소비 앱의 semantic alias 책임).
 *
 * 커스텀 드로잉 — c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split
 * §아이콘). 24 그리드 / stroke 기반. 노브 원(r=2)의 바깥선과 트랙 끝 round cap 이 맞닿도록
 * 트랙을 노브 중심 ±4 에서 끊는다.
 */
export const SlidersIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M3 6h8M19 6h2" />
    <circle cx="15" cy="6" r="2" />
    <path d="M3 12h1M12 12h9" />
    <circle cx="8" cy="12" r="2" />
    <path d="M3 18h6M17 18h4" />
    <circle cx="13" cy="18" r="2" />
  </svg>
);
